module.exports = __webpack_public_path__ + "img/AUDI.68e3d19.jpg";